import React from 'react';
import './ShiftDetailComponent.scss';
import 'stylesheets/fonts.scss';
import 'stylesheets/layout.scss';


import { Mixpanel } from 'helpers/Mixpanel';
import formatter from '../../../duck/formatter';
import presenter from 'pages/ScheduleCalendar/duck/presenter';
import { injectIntl } from 'react-intl';
import draftLogic from 'pages/ScheduleCalendar/duck/draftLogic';
import timeUtil from 'pages/ScheduleCalendar/duck/timeUtil';
import { getUserId } from 'helpers/cookies';
import { isValidObject } from 'helpers/validation';

import DetailFieldAssignToComponent from './DetailFieldAssignToComponent';
import DetailFieldTimeComponent from './DetailFieldTimeComponent';
import DetailFieldPostToGroupComponent from './DetailFieldPostToGroupComponent';
import DetailFieldPositionComponent from './DetailFieldPositionComponent';
import DetailFieldQuantityComponent from './DetailFieldQuantityComponent';
import DetailFieldPillTagsComponent from './DetailFieldPillTagsComponent';
import DetailFieldSelectWeekdayComponent from './DetailFieldSelectWeekdayComponent';
import DetailFieldDescriptionComponent from './DetailFieldDescriptionComponent';
import DetailFieldSkillComponent from './DetailFieldSkillComponent';
import DetailFieldRoleContainer from './DetailFieldRoleContainer';

import displayLogic from 'pages/ScheduleCalendar/duck/displayLogic';
import service from 'pages/ScheduleCalendar/duck/service';
import constants from 'pages/ScheduleCalendar/constants';
import { findFirstRoleTag } from 'pages/ScheduleCalendar/duck/tagUtil';

class ShiftFieldsComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      shiftStartTime: timeUtil.defaultStart(props.date).format(formatter.hourTimeZoneFormat()),
      shiftEndTime: timeUtil.defaultEnd(props.date).format(formatter.hourTimeZoneFormat()),
      jobTitle: '',
      shouldDisplayOvernightShift: false,
      shouldDisplayJobTitleLengthWarning: false,
      selectedDays: [this.getSelectedWeekday()],

      assignToTarget: null,
      postToGroupTarget: null,
      bulkQuantity: 1,
      descriptionOfShift: '',
      selectedRoles: [],
      selectedSkills: [],
    };
  }

  componentDidMount() {
    const { date, presentedShift, userToAddShiftTo, channels, creationType, fetchChannelMembers } = this.props;

    if( isValidObject(presentedShift) == true ){
      this.populateFieldsFromShift()
    }else {
      if( creationType == constants.ShiftCreationType.Inventory && isValidObject(userToAddShiftTo) == true && isValidObject(date) == true ){
         this.setState({assignToTarget : userToAddShiftTo}) ;
      }else{
        if ( creationType == constants.ShiftCreationType.VTO ){
          this.setState({assignToTarget : presenter.vtoSelectionTarget() })
        }else if ( creationType == constants.ShiftCreationType.OpenShift ){
          this.setState({assignToTarget : presenter.openShiftSelectionTarget() })
        }

        const defaultLocationGroup = presenter.getDefaultLocationGroup(channels);
        if( isValidObject(defaultLocationGroup) == true ){
          this.setState({postToGroupTarget: defaultLocationGroup});
          // Fetch channel members for the default location group
          if (defaultLocationGroup.id) {
            fetchChannelMembers(defaultLocationGroup.id);
          }
        }
      }
    }
  }

  populateFieldsFromShift = () => {
    const { shiftStartTime, shiftEndTime, jobTitle } = this.state;
    const { date, presentedShift, allUsers, unregisteredUsers, channels, fetchChannelMembers } = this.props;

    if( jobTitle == '' ){
      const shiftJobTitle = presentedShift?.primary_job;
      this.setState({ jobTitle: shiftJobTitle});
    }

    if( presentedShift?.total_shifts_available> 0 ){ this.setState({ bulkQuantity: presentedShift?.total_shifts_available }); }

    if (timeUtil.isOvernightShift(shiftStartTime, shiftEndTime, date)) { this.setState({ shouldDisplayOvernightShift: true }); }

    const subtype = service.getShiftSubType(presentedShift)
    if( subtype !== constants.ShiftSubType.ParentOpenShift && subtype !== constants.ShiftSubType.DraftOpenShift && subtype !== constants.ShiftSubType.ParentVTO && subtype !== constants.ShiftSubType.DraftVTO ){
      const target = presenter.userShiftIsAssignedTo(presentedShift, allUsers, unregisteredUsers)
      this.setState({ assignToTarget:target }) 
    }else if ( subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO ){
      this.setState({ assignToTarget: presenter.vtoSelectionTarget() })
    }else if ( subtype == constants.ShiftSubType.ParentOpenShift || subtype == constants.ShiftSubType.DraftOpenShift ){
      this.setState({ assignToTarget: presenter.openShiftSelectionTarget() })
    }

    const groupToPostTo = presenter.getGroup(presentedShift, channels);

    console.log("Shift:" + presentedShift);

    this.setState({shiftStartTime: formatter.pickerHourTimeZoneFormat(presentedShift.start_at),
      shiftEndTime: formatter.pickerHourTimeZoneFormat(presentedShift.end_at),
      descriptionOfShift: presentedShift.content,
      postToGroupTarget: groupToPostTo,
      selectedRoles: this.getShiftRoles(presentedShift.non_filter_tag_ids).slice(0, 1), // Only take the first role for single selection
      selectedSkills: this.getShiftSkills(presentedShift.skill_ids) // Get all skills
     })

    // Fetch channel members for the group from the shift
    if (groupToPostTo && groupToPostTo.id) {
      fetchChannelMembers(groupToPostTo.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { date, roles, fetchChannelMembers } = this.props;
    const { shiftStartTime, shiftEndTime, selectedRoles, postToGroupTarget } = this.state;

    // If the shift start or end time changes, check if it is an overnight shift
    if (prevState.shiftStartTime !== shiftStartTime || prevState.shiftEndTime !== shiftEndTime) {
      const result = timeUtil.isOvernightShift(shiftStartTime, shiftEndTime, date);
        this.setState({ shouldDisplayOvernightShift: result });
    }

    // Update selectedRoles if the roles in Redux have been updated
    if (selectedRoles.length > 0 && roles && prevProps.roles !== roles) {
      const currentSelectedRole = selectedRoles[0];
      const updatedRole = roles.find(role => role.id === currentSelectedRole.id);
      if (updatedRole && updatedRole.color_code !== currentSelectedRole.color_code) {
        console.log('Updating selected role with new color:', updatedRole);
        this.setState({ selectedRoles: [updatedRole] });
      }
    }

    // Fetch channel members when postToGroupTarget changes
    if (postToGroupTarget && postToGroupTarget.id && 
        (prevState.postToGroupTarget?.id !== postToGroupTarget.id)) {
      const { channelMembers } = this.props;
      // console.log('[ShiftFieldsComponent] componentDidUpdate - postToGroupTarget changed to channelId:', postToGroupTarget.id);
      // console.log('[ShiftFieldsComponent] componentDidUpdate - current channelMembers before fetch:', channelMembers?.length || 0, 'members');
      fetchChannelMembers(postToGroupTarget.id);
    }
    
    // Debug: Log when channelMembers prop changes
    if (prevProps.channelMembers !== this.props.channelMembers) {
      // console.log('[ShiftFieldsComponent] componentDidUpdate - channelMembers prop changed');
      // console.log('[ShiftFieldsComponent] componentDidUpdate - new channelMembers:', this.props.channelMembers?.length || 0, 'members');
      // console.log('[ShiftFieldsComponent] componentDidUpdate - channelMembers sample:', this.props.channelMembers?.slice(0, 3));
    }
  }

  getSelectedWeekday = () => {
    const { date } = this.props;
    const weekdayIndex = date.isoWeekday() - 1; // Monday is 0, Sunday is 6
    return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'][weekdayIndex];
  };

  startTimeChanged = (time) => {
    if (time) {
      const val = time.format(formatter.hourTimeZoneFormat());
      this.setState({ shiftStartTime: val });
    }
  };

  endTimeChanged = (time) => {
    if (time) {
      const val = time.format(formatter.hourTimeZoneFormat());
      this.setState({ shiftEndTime: val });
    }
  };

  handleJobTitleChange = (event) => {
    const val = event.target.value;
    if (val && val.length > 35) {
      this.setState({
        shouldDisplayJobTitleLengthWarning: true,
      });
    } else {
      this.setState({
        jobTitle: val,
        shouldDisplayJobTitleLengthWarning: false,
      });
    }
    this.validateInputs();
  };

  handleSelectedDaysChange = (selectedDays) => { this.setState({ selectedDays }); };

  handleConfirm = (e) => {
    const { userToAddShiftTo, date, addDraftShiftToUserDispatch, locationData, cancelModal, addDraftOpenShiftToUserDispatch, roles, addDraftVTOToUserDispatch } = this.props;
    const { assignToTarget, shiftStartTime, shiftEndTime, jobTitle, selectedDays, postToGroupTarget, bulkQuantity, descriptionOfShift, selectedRoles, selectedSkills } = this.state;

    if ( this.validateInputs() == false ){ return;}

    const roleIds = selectedRoles.map(role => role.id);
    const skillIds = selectedSkills.map(skill => skill.id);
    const roleNameOrJobTitle = presenter.getRoleNameOrJobTitle(selectedRoles, jobTitle);

    if( assignToTarget?.assignToOpenShift == true ){
      console.log(bulkQuantity + ' , ' + postToGroupTarget.id + ' ' + descriptionOfShift);
      addDraftOpenShiftToUserDispatch(getUserId(), shiftStartTime, shiftEndTime, roleNameOrJobTitle, locationData.id, selectedDays, date, locationData.fiscal_day, postToGroupTarget.id, bulkQuantity, descriptionOfShift, roleIds, skillIds); 
       Mixpanel.track('Confirm add open shift');
    }else if ( assignToTarget?.assignToVTO == true ){
      console.log(bulkQuantity + ' , ' + postToGroupTarget.id + ' ' + descriptionOfShift);
      addDraftVTOToUserDispatch(getUserId(), shiftStartTime, shiftEndTime, roleNameOrJobTitle, locationData.id, selectedDays, date, locationData.fiscal_day, postToGroupTarget.id, bulkQuantity, descriptionOfShift, roleIds, skillIds); 
       Mixpanel.track('Confirm add VTO');
    }else{
      addDraftShiftToUserDispatch(assignToTarget, shiftStartTime, shiftEndTime, roleNameOrJobTitle, locationData.id, selectedDays, date, locationData.fiscal_day, roleIds, skillIds);
      Mixpanel.track('Confirm add shift', { start_time: shiftStartTime, end_time: shiftEndTime, job_title: jobTitle });
    }
    e.preventDefault();
    cancelModal();
  };

  handleDeleteClick = () => {
    const { prepareToDeleteShift, presentedShift, cancelModal, locationSettings} = this.props;
    const subtype = service.getShiftSubType(presentedShift); 
    prepareToDeleteShift(presentedShift.id, presentedShift.location_id, displayLogic.isRevokableChildShift(subtype, locationSettings));
    cancelModal();
  };

  handleStartCopyClick = () => {
    const { prepareToCopyShift, cancelModal, presentedShift} = this.props;

    if( isValidObject(presentedShift) == true ){
      prepareToCopyShift(presentedShift);
      cancelModal();
      Mixpanel.track('Start Copy Shift');
   }
  }
  handleCancel = () => {
    const { cancelModal } = this.props;
    cancelModal();
    Mixpanel.track('Cancel shift detail');
  }

  handleUpdateClick = () => {
    const {updateDraftVTOShiftDispatch, reassignTeamShiftDispatch, updatePublishedVTOShiftDispatch, updateDraftOpenShiftDispatch, updateDraftShiftDispatch, updatePublishedOpenShiftDispatch, date, presentedShift, cancelModal, roles } = this.props;
    const { shiftStartTime, shiftEndTime, jobTitle, descriptionOfShift, bulkQuantity, postToGroupTarget, assignToTarget, selectedRoles, selectedSkills } = this.state;
    const subtype = service.getShiftSubType(presentedShift); 
    const roleIds = selectedRoles.map(role => role.id);
    const skillIds = selectedSkills.map(skill => skill.id);

    const roleTag = findFirstRoleTag(roles, presentedShift);
    const positionOrRoleName = presenter.getRoleNameOrJobTitle([roleTag], jobTitle);
    
    if( subtype == constants.ShiftSubType.ParentOpenShift ){
      // TODO: Add skillIds parameter when the API supports it
      updatePublishedOpenShiftDispatch(presentedShift, bulkQuantity, descriptionOfShift, jobTitle, roleIds, skillIds);
      Mixpanel.track('Update published open shift')
    }else if ( subtype == constants.ShiftSubType.DraftOpenShift ){
      // TODO: Add skillIds parameter when the API supports it
      updateDraftOpenShiftDispatch(presentedShift.id, presentedShift.owner_id, shiftStartTime, shiftEndTime, positionOrRoleName, presentedShift.location_id,date, postToGroupTarget.id, bulkQuantity, descriptionOfShift, roleIds, skillIds)
      Mixpanel.track('Update draft open shift')
    }else if ( subtype == constants.ShiftSubType.ParentVTO ){
      // TODO: Add skillIds parameter when the API supports it
      updatePublishedVTOShiftDispatch(presentedShift, bulkQuantity, descriptionOfShift, jobTitle, roleIds, skillIds);
      Mixpanel.track('Update published VTO shift')
    }else if ( subtype == constants.ShiftSubType.DraftVTO ){
      // TODO: Add skillIds parameter when the API supports it
      updateDraftVTOShiftDispatch(presentedShift.id, presentedShift.owner_id, shiftStartTime, shiftEndTime, positionOrRoleName, presentedShift.location_id,date, postToGroupTarget.id, bulkQuantity, descriptionOfShift, roleIds, skillIds)
      Mixpanel.track('Update draft VTO shift')
    }else if ( subtype == constants.ShiftSubType.TeamShift ){
      reassignTeamShiftDispatch(presentedShift, assignToTarget.owner_id);
      Mixpanel.track('Reassign team shift');
    }else{
      updateDraftShiftDispatch(presentedShift, shiftStartTime, shiftEndTime, positionOrRoleName, date, roleIds);
      Mixpanel.track('Update draft inventory');
    }
    cancelModal();
  }

  selectAssignTarget = (target)  => {
    this.setState( {assignToTarget: target} );
    this.validateInputs();
  }

  selectGroup = (target) => {
    // console.log(JSON.stringify(target));
    // console.log('[ShiftFieldsComponent] selectGroup called with target:', target);
    this.setState( {postToGroupTarget: target} );
    this.validateInputs();
    
    // Fetch channel members when channel changes
    if (target && target.id) {
      const { fetchChannelMembers, channelMembers } = this.props;
      // console.log('[ShiftFieldsComponent] selectGroup - calling fetchChannelMembers for channelId:', target.id);
      // console.log('[ShiftFieldsComponent] selectGroup - current channelMembers before fetch:', channelMembers?.length || 0, 'members');
      fetchChannelMembers(target.id);
    }
  }

  selectRoles = (target) => {
    // console.log(JSON.stringify(target));
    if( target == null || target.length == 0 ){
      this.setState( {selectedRoles: []} );
    }else{
      this.setState( {selectedRoles: [target]} );
    }
    this.validateInputs();
  }

  selectSkills = (target) => {
    // console.log(JSON.stringify(target));
    this.setState({ selectedSkills: target });
    this.validateInputs();
  }

  handleQuantityChange = (event) => { this.setState({ bulkQuantity: event.target.value});  this.validateInputs();}
  handleDescriptionChange = (event) => { this.setState({ descriptionOfShift: event.target.value}); this.validateInputs(); }
  handleRoleChange = (roles) => { this.setState({ selectedRoles: roles }); this.validateInputs(); }

  getShiftRoles = (roleIds) => {
    const { roles } = this.props;
    if (!roleIds || !roles) return [];
    
    return roles.filter(role => (roleIds.includes(role.id) && role.tag_type === 'role'));
  }

  getShiftSkills = (skillIds) => {
    const { skills } = this.props;
    if (!skillIds || !skills) return [];
    
    return skills.filter(skill => skillIds.includes(skill.id));
  }

  validateInputs = () => {
    const {assignToTarget, postToGroupTarget, jobTitle, bulkQuantity} = this.state;
    if(assignToTarget != null && (assignToTarget.assignToOpenShift == true  || assignToTarget.assignToVTO == true) ){
      if ( isValidObject(postToGroupTarget) == true &&
          isValidObject(jobTitle) == true && 
          bulkQuantity > 0) {
        return true;
      }else{
        return false;
      }
    }else{
      return true
    }
  };

  render() {
    const {creationType, allUsers, channels, date, locationData, presentedShift, applicants, isOpenShiftConfigured, isVTOConfigured = false, locationSettings, roles, skills, channelMembers } = this.props;
    const { shiftStartTime, shiftEndTime, bulkQuantity, postToGroupTarget, shouldDisplayOvernightShift, shouldDisplayJobTitleLengthWarning, selectedDays, assignToTarget } = this.state;

    const isViewingShift = (isValidObject(presentedShift) == true);
    var allowShiftDelete = false;

    const selectedGroupName = postToGroupTarget?.channel_name;
    const subtype = service.getShiftSubType(presentedShift); 

    if( isViewingShift ){
      allowShiftDelete = displayLogic.shouldShowDeleteButton(subtype, presentedShift, locationSettings);
    }

    const areInputsValidated = this.validateInputs();
    const shouldShowSaveButton = displayLogic.shouldShowSaveButton(subtype, presentedShift, assignToTarget)
    const showOpenShiftForAssignList = displayLogic.showOpenShiftForAssignList(isOpenShiftConfigured, subtype);
    const showVTOForAssignList = displayLogic.showVTOForAssignList(isVTOConfigured, subtype);
    const isSkillsConfigured = (locationSettings.cfg__skill == 1);

    // console.log("Skills: " + JSON.stringify(skills));

    return (
        <div className='shift-fields-container'>
    
          {displayLogic.shouldShowPillTags(subtype) == true && 
            <DetailFieldPillTagsComponent shift={presentedShift} applicants={applicants} subtype={subtype}/> }
         
          <div className='flex-row top-row'>
            <DetailFieldAssignToComponent 
                disableField = {displayLogic.disableAssignToField(subtype)}
                allUsers={allUsers} 
                selectAssignTarget={this.selectAssignTarget} 
                assignToTarget={assignToTarget}
                showOpenShiftForAssignList = {showOpenShiftForAssignList}
                showVTOForAssignList = {showVTOForAssignList} /> 

            {displayLogic.shouldShowQuantityField(assignToTarget, subtype) == true &&
              <DetailFieldQuantityComponent 
                presentedShift={presentedShift}
                bulkQuantity ={bulkQuantity}
                handleQuantityChange={this.handleQuantityChange}/> }
          </div>

          <DetailFieldTimeComponent 
              disableField={displayLogic.disableTimeField(presentedShift)}  
              shouldDisplayOvernightShift={shouldDisplayOvernightShift} 
              date={date} presentedShift={presentedShift} 
              startTimeChanged={this.startTimeChanged} endTimeChanged={this.endTimeChanged}
              startTime={shiftStartTime} endTime={shiftEndTime} />

          {displayLogic.shouldShowPostToGroupField(assignToTarget, subtype) == true && 
            <DetailFieldPostToGroupComponent 
               disableField={displayLogic.disablePostToGroupField(subtype)} 
               channels={channels} 
               selectGroup={this.selectGroup} 
               groupDisplayText={selectedGroupName}/>}

          {displayLogic.shouldShowRoleField(subtype, presentedShift, roles) == false && 
          <DetailFieldPositionComponent 
              defaultValue={presentedShift?.primary_job} 
              disableField={displayLogic.disablePositionField(subtype)} 
              handleJobTitleChange={this.handleJobTitleChange}
              shouldDisplayLengthWarning={shouldDisplayJobTitleLengthWarning} /> }

           {displayLogic.shouldShowRoleField(subtype, presentedShift, roles) == true && 
           <DetailFieldRoleContainer 
               selectRoles={this.handleRoleChange}
              roleDisplayText={this.state.selectedRoles && (this.state.selectedRoles.length > 0 ? this.state.selectedRoles[0].name : 'Select roles')}
              disableField={displayLogic.disableRoleField(subtype)}
              selectedRole={(this.state.selectedRoles !== null && this.state.selectedRoles.length > 0) ? this.state.selectedRoles[0] : null} /> }

          {/* Show skills field for open shifts and VTOs */}
          { displayLogic.shouldShowSkillField(subtype, isSkillsConfigured) == true && 
            <DetailFieldSkillComponent
              groupToPostTo={postToGroupTarget}
              skills = {skills}
              selectSkills={this.selectSkills}
              skillDisplayText={this.state.selectedSkills && this.state.selectedSkills.length > 0 ? 
                this.state.selectedSkills.map(skill => skill.skill_content).join(', ') : 'Select skills'}
              disableField={displayLogic.disableSkillField(subtype)}
              selectedSkills={this.state.selectedSkills}
              allUsers={allUsers}
              channelMembers={channelMembers} /> }
        
          {displayLogic.shouldShowDescriptionField(assignToTarget, subtype) == true &&
            <DetailFieldDescriptionComponent 
              defaultValue = {presentedShift?.content}
              disableField={displayLogic.disableDescriptionField(subtype)}
              handleDescriptionChange={this.handleDescriptionChange}
              author= {presenter.getPoster(presentedShift, allUsers)}
              subtype={subtype}
              creationType={creationType} /> }

          {displayLogic.shouldShowSelectWeekdayField(subtype) == true &&
            <DetailFieldSelectWeekdayComponent 
              disableManualSelect={isViewingShift} 
              locationData={locationData} 
              selectedDay={this.getSelectedWeekday()} 
              selectedDays={selectedDays} 
              onChange={this.handleSelectedDaysChange} /> }

          <div className="button-row">
            <div>          
              {allowShiftDelete && <button className='delete-button' onClick={this.handleDeleteClick}>{presenter.deleteText(subtype)}</button>}
              {displayLogic.shouldShowCopyButton(subtype, isViewingShift) && <button className='copy-button' onClick={this.handleStartCopyClick}>{presenter.copyText(subtype)}</button>}
            </div>

            <div>
              { shouldShowSaveButton == true && <button className='cancel-button' onClick={this.handleCancel}> {presenter.cancelText()}</button> } 
              { shouldShowSaveButton == true && <button className='save-button' onClick={this.handleUpdateClick}> {presenter.saveText()}</button> }
              {isViewingShift == false && <button className={ 'narrow-height confirm-button ' + (areInputsValidated==true ? 'button-enabled' : 'button-disabled')} onClick={this.handleConfirm} > {presenter.addObjectText(creationType)} </button>}
            </div>
          </div>
        </div>
    );
  }
}

export default injectIntl(ShiftFieldsComponent);
